import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { PostUserKYCPayload, PostUserKYCResponse } from './types/Kyc';

export default (makeCall: MakeCall) =>
  (userId: 'me' | number, data: Partial<PostUserKYCPayload>) =>
    makeCall<PostUserKYCResponse>('POST', `/api/v2/user/${userId}/kyc`, {
      data,
    });
